import { handleActions } from 'redux-actions';
import { RemoteData } from 'rf-lib';
import * as t from './constants';

const defaultState = {
  loginState: RemoteData.NotAsked
};

const reducer = handleActions({
  [t.LOGIN]: (state, action) => ({
    ...state, loginState: RemoteData.Loading
  }),

  [t.LOGIN_FAILURE]: (state, action) => ({
    ...state, loginState: RemoteData.Failure(action.payload)
  }),

  [t.LOGIN_SUCCESS]: (state, action) => ({
      ...state, loginState: RemoteData.Success(action.payload)
  }),
  [t.RESET_STATE]: state => ({
    ...state, loginState: RemoteData.NotAsked
  }),
}, defaultState);

export default reducer;
